export default function Card({ children, title, icon, action, className = '', ...props }) {
    return (
        <div className={`card ${className}`} {...props}>
            {(title || action) && (
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        {icon}
                        {title && <h3 className="text-lg font-semibold">{title}</h3>}
                    </div>
                    {action}
                </div>
            )}
            {children}
        </div>
    );
}

